import React from 'react';
import { Field } from 'redux-form';
import { compose, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { Multiselect } from 'react-widgets';
import 'react-widgets/dist/css/react-widgets.css';
import { t } from '../../../../../modules/infra/i18n';
import { getPermissionsForKind } from '../../selectors';
import { fetchPermissionsForKind } from '../../actions';

const renderSelect = ({ input, data, valueField, textField, meta: { touched, error } }) =>
  <div className="u-position-relative">
    <div className="c-label-new">{t('admin:user_permissions.label')}</div>
    <Multiselect
      {...input}
      onBlur={() => input.onBlur()}
      value={input.value}
      data={data}
      valueField={valueField}
      textField={textField}
      filter="contains"
    />
    {touched && error && <div className="c-input-error-message">{error}</div>}
  </div>;

const UserPermissions = ({ permissions, name }) => (
  <Field
    name={name}
    component={renderSelect}
    data={permissions}
    valueField="id"
    textField="operation"
  />
);

const mapStateToProps = (state, ownProps) => ({
  permissions: getPermissionsForKind(state, ownProps.kind),
});

const mapDispatchToProps = {
  fetchPermissionsForKind,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      this.props.fetchPermissionsForKind(this.props.kind);
    },
  })
)(UserPermissions);
